import { render } from "./AvatarCreationExperience.vue?vue&type=template&id=2b89f57a&scoped=true"
import script from "./AvatarCreationExperience.js?vue&type=script&lang=js"
export * from "./AvatarCreationExperience.js?vue&type=script&lang=js"

import "./AvatarCreationExperience.scss?vue&type=style&index=0&id=2b89f57a&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b89f57a"]])

export default __exports__